import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { LiveshopService } from "src/app/services/liveshop/liveshop.service";

@Component({
  selector: "app-media-stream-permissions",
  templateUrl: "./media-stream-permissions.component.html",
  styleUrls: ["./media-stream-permissions.component.scss"],
})
export class MediaStreamPermissionsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<MediaStreamPermissionsComponent>,
    public liveshopService: LiveshopService
  ) {}

  ngOnInit(): void {
    // navigator.permissions.query({ name: "camera" }).then((permissionStatus) => {
    //   console.log(permissionStatus);
    // });
    // navigator.permissions.query({ name: "microphone" }).then((permissionStatus) => {
    //   console.log(permissionStatus);
    // });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
